export function derivePlanningInputTags(
  itemPoolIds: string[] | undefined,
  tagsByPoolId: Map<string, string[]>
): string[] {
  return Array.from(
    new Set((itemPoolIds ?? []).flatMap((itemPoolId) => tagsByPoolId.get(itemPoolId) ?? []))
  );
}
